import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home.vue";
// import About from '@/components/About'
// import Mapview from "@/components/Mapview";
import Projects from "@/components/Projects";
import PerformanceIndicators from "@/components//data/PerformanceIndicators.vue";
import CriticalMineral from "@/components/data/CriticalMineral.vue";
import GenderMobility from "@/components/data/GenderMobility.vue";
import RAI from "@/components/RAI.vue";
import Test from "@/components/Test";
import Tools from "@/components/Tools.vue";
import PlaceholderTool from "@/components/tools/PlaceholderTool.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/projects",
    name: "projects",
    component: Projects,
  },
  {
    path: "/performance-indicators",
    name: "performance-indicators",
    component: PerformanceIndicators,
  },
  {
    path: "/critical-mineral",
    name: "critical-mineral",
    component: CriticalMineral,
  },
  {
    path: "/gender-mobility",
    name: "gender-mobility",
    component: GenderMobility,
  },
  {
    path: "/rai",
    name: "rai",
    component: RAI,
  },
  {
    path: "/test",
    name: "test",
    component: Test,
  },
  {
    path: "/tools",
    name: "tools",
    component: Tools,
  },
  {
    path: "/tools/flowmax",
    name: "tools-flowmax",
    component: PlaceholderTool,
    meta: { title: "FlowMax" },
  },
  {
    path: "/tools/cyclemax",
    name: "tools-cyclemax",
    component: PlaceholderTool,
    meta: { title: "CycleMax" },
  },
  {
    path: "/tools/path",
    name: "tools-path",
    component: PlaceholderTool,
    meta: { title: "PATH" },
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
